import type { ReactNode } from "react";

/**
 * Shared page shell for every pre-auth card surface (sign-in/up, password
 * flows, verify-email, beta invite, household join). Centers a single
 * Organic card on the cream ground with two soft, blurred accent blobs
 * behind it (organic-readme.md: "soft shapes as decoration"). Purely
 * decorative and visual -- it owns no state, no data fetching, and no
 * business logic, so it's safe to reuse across the safety-critical
 * /join/[token] flow without touching that page's behavior.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-svh items-center justify-center overflow-hidden bg-background p-4">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-sage-200/40 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 -bottom-24 h-80 w-80 rounded-full bg-terracotta-200/40 blur-3xl"
      />
      <div className="relative w-full max-w-md">{children}</div>
    </div>
  );
}
